import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import {
    createAsyncActionTypes,
    createAsyncMetaSelectors,
    createScopedReducer,
    createScopedSelector,
} from '@mews/framework';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { getCurrentEnterprisePaymentIdsByBillId } from '@mews-commander/legacy-entities/src/ducks';
import { getCurrentEnterprisePaymentsByServiceOrderId } from '@mews-commander/legacy-entities/src/ducks/payments';
import { moduleSelector as parentSelector, prefix } from '../module';

export const NAME = 'payments';

const PAYMENT_FETCH = prefix('PAYMENT_FETCH');
export const [PAYMENT_FETCH_STARTED, PAYMENT_FETCH_SUCCEEDED, PAYMENT_FETCH_FAILED] =
    createAsyncActionTypes(PAYMENT_FETCH);

const initialState = META_STATE_SUCCEEDED;

export const paymentReducer = createScopedReducer(
    initialState,
    createEntityAsyncMetaHandlers({
        STARTED: PAYMENT_FETCH_STARTED,
        SUCCEEDED: PAYMENT_FETCH_SUCCEEDED,
        FAILED: PAYMENT_FETCH_FAILED,
    })
);

const moduleSelector = createSelector(parentSelector, get(NAME));

const getScope = createScopedSelector({ parentSelector: moduleSelector, initialState });

const getMeta = createSelector(getScope, get('meta'));

export const [isPaymentFetching] = createAsyncMetaSelectors(getMeta);

export const getBillPaymentsWithServiceOrderId = createSelector(
    getCurrentEnterprisePaymentIdsByBillId,
    getCurrentEnterprisePaymentsByServiceOrderId,
    (billPaymentIds, reservationPayments) => reservationPayments.filter(({ id }) => billPaymentIds.includes(id))
);

export const getBillPaymentIdsWithServiceOrderId = createSelector(getBillPaymentsWithServiceOrderId, (payments) =>
    payments.map(({ id }) => id)
);
